let aba = "all";
if (window.location.href.toLowerCase().indexOf("cursos") > -1) aba = "cursos";
if (window.location.href.toLowerCase().indexOf("lives") > -1) aba = "mentorias";
if (window.location.href.toLowerCase().indexOf("workshops") > -1)
  aba = "workshops";
if (window.location.href.toLowerCase().indexOf("pocketbook") > -1)
  aba = "pocket";
if (window.location.href.toLowerCase().indexOf("materiais-educativos") > -1)
  aba = "materiais";
if (window.location.href.toLowerCase().indexOf("master-class") > -1)
  aba = "mclassName";
if (window.location.href.toLowerCase().indexOf("voittocast") > -1)
  aba = "vcast";
if (window.location.href.indexOf("universidade") > -1) aba = "cursos";

const INITIAL_STATE = {
  aba,
  cursos_arr: [],
  ulti_transmissoes: [],
  artigos_recentes: [],
  segmento_especifico: [],
  ultimas_mentorias: [],
  //cursos: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CHANGE_ABA":
      if (state.aba == "cursos" && action.payload == "cursos") {
        window.location.href = "/cursos";
      }
      return { ...state, aba: action.payload };
    case "CHANGE_ABA_NEW":
      return { ...state, aba: action.payload };
    case "CHANGE_ABA_NODE":
      return { ...state, aba: action.payload };

    default:
      return state;
  }
};
